/**
 * 来款记录
 *
 * @author FJJ
 * @version 1.0
 *
 * Copyright 2022, all rights reserved. Essa.cn
 * */
import React from 'react'
import CommonBreadcrumb from "@components/CommonBreadcrumb";

import Lang from "@components/Lang/Lang";
import AutoFetchTable from "@components/AutoFetchTable/AutoFetchTable";
import {getColumnsIn} from "../component/PaymentColumns";
import "./index.less";

export default class PaymentCheckOutRecord extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            //加载中
            loading: true,
            // 列
            columns: getColumnsIn(),
            searchFormOptions:[
                {
                    name:'keyWord',
                    cnPlaceholder:'请输入客户编码或名称',
                    cnPlaceholderId:'QingShuRuCaiGouShangBianMaHuoMingCheng ',
                    hiddenLabel:true,
                },
                {
                    name:'time',
                    cnPlaceholder:[Lang({id:'KaiShiShiJian',default:'开始时间'}),Lang({id:'JieShuShiJian',default:'结束时间'})],
                    cnPlaceholderId:['KaiShiShiJian','JieShuShiJian'],
                    searchRange:['startTime','endTime'],
                    type:'DateRangePicker',
                    width:300,
                    hiddenLabel:true,
                    canSearch:false,
                },
            ],

        };
    }
    onRefTabOne = (ref) =>  this.onRefTabChildOne = ref;

    componentDidMount() {
        // this.getData();
    }
    render(){
        const { columns,searchFormOptions } = this.state;
        return (
            <>
                <CommonBreadcrumb
                    list={[
                        { name:Lang({id: 'LaiKuanDengJi', default: '来款登记'}),link:"/financeManagement/paymentCheckIn"},
                        { name: Lang({id: 'LaiKuanJiLu', default: '来款记录'})}
                    ]}
                ></CommonBreadcrumb>
                <div className={"main-wrap"}>
                    <div className="mb_16 font_18 fw_700">{Lang({id: 'LaiKuanJiLu', default: '来款记录'})}</div>
                    {/*表格*/}
                    <AutoFetchTable columns={columns}
                                    searchFormOptions={searchFormOptions}
                                    exportSetting = {
                                        {
                                            exportUrl: '/data/bpms/jreport/mg/fexiao/fin/remittance/print',
                                            exportTemplate: 'MgFenxiaoRemittanceReport',
                                            authName:'PaymentCheckIn-Record-Export-Button'
                                        }
                                    }
                                    onRef={this.onRefTabOne}
                                    scroll={{ x: 1200 }}
                                    flagShowReset = {false}
                                    pageSize={50}
                                    fetchApi={'/service/mg/fin/ddp/remittance-item/remittanceList'}>
                    </AutoFetchTable>
                </div>
            </>
        )
    }
}

